module.exports = __webpack_public_path__ + "img/academy-company.3b56e3af.png";